/**
 * This file contains constants related to invoices and payouts
 */

// Types of files that user can upload as custom templates for invoices and payouts
export const CUSTOM_FILE_ACCEPTED_TYPES = [
  '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.txt', '.jpeg', '.jpg', '.png', '.gif'
]

// File extension for which the preview is available
export const PREVIEWABLE_FILE_EXTENSIONS = [
  '.pdf', '.txt', '.jpeg', '.jpg', '.png', '.gif'
]
